module.exports = __webpack_public_path__ + "media/images/icon-youtube-c2c5e2f6f49db25af666f65a5ba530d1.svg";